import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import ThemeSelector from './ThemeSelector';
import { useAuth } from '../hooks/useAuth';
import AuthComponent from './AuthComponent';
import { OrganizationSwitcher } from './OrganizationSwitcher';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const dashboardHref = '/console';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navLinkStyle = {
    color: 'var(--text-primary)',
    backgroundColor: 'transparent',
  };

  const navLinkHoverStyle = {
    color: 'var(--accent)',
    backgroundColor: 'var(--bg-secondary)',
  };

  const getActiveLinkStyle = (path: string) => {
    const isActive = location.pathname === path;
    return {
      ...navLinkStyle,
      ...(isActive && {
        color: 'var(--accent)',
        backgroundColor: 'var(--bg-secondary)',
        fontWeight: '600',
      }),
    };
  };

  const getDashboardLinkStyle = () => {
    const isActive =
      location.pathname === '/console' ||
      location.pathname.startsWith('/admin');

    return {
      ...navLinkStyle,
      ...(isActive && {
        color: 'var(--accent)',
        backgroundColor: 'var(--bg-secondary)',
        fontWeight: '600',
      }),
    };
  };

  return (
    <header
      className="sticky top-0 z-50 border-b shadow-sm"
      style={{
        backgroundColor: 'var(--bg-primary)',
        borderColor: 'var(--border)',
        color: 'var(--text-primary)',
      }}
    >
      <div className="mx-auto px-4 py-2">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="logo">
            <Link to="/" className="text-decoration-none" onClick={closeMenu}>
              <h1
                className="text-xl sm:text-2xl font-bold m-0"
                style={{ color: 'var(--accent)' }}
              >
                SudoSys
              </h1>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-2">
            <nav>
              <ul className="flex gap-2 list-none m-0 p-0">
                <li>
                  <Link
                    to="/"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/')
                      );
                    }}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/about')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/about') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/about')
                      );
                    }}
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/services')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/services') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/services')
                      );
                    }}
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/products"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/products')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/products') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/products')
                      );
                    }}
                  >
                    Products
                  </Link>
                </li>
                <li>
                  <Link
                    to="/pricing"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/pricing')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/pricing') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/pricing')
                      );
                    }}
                  >
                    Pricing
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to="/portfolio"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/portfolio')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/portfolio') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/portfolio')
                      );
                    }}
                  >
                    Portfolio
                  </Link>
                </li> */}
                <li>
                  <Link
                    to="/contact"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/contact')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/contact') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/contact')
                      );
                    }}
                  >
                    Contact
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to="/blog"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/blog')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/blog') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/blog')
                      );
                    }}
                  >
                    Blog
                  </Link>
                </li> */}
                {/* <li>
                  <Link
                    to="/newsletter"
                    className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                    style={getActiveLinkStyle('/newsletter')}
                    onMouseEnter={e => {
                      if (location.pathname !== '/newsletter') {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getActiveLinkStyle('/newsletter')
                      );
                    }}
                  >
                    Newsletter
                  </Link>
                </li> */}

                {/* Authenticated user links */}
                {isAuthenticated && (
                  <li>
                    <Link
                      to={dashboardHref}
                      className="font-medium px-3 py-2 rounded-md transition-all duration-200 hover:scale-105 no-underline"
                      style={getDashboardLinkStyle()}
                      onMouseEnter={e => {
                        const isDashboardActive =
                          location.pathname === '/console' ||
                          location.pathname.startsWith('/admin');
                        if (!isDashboardActive) {
                          Object.assign(
                            e.currentTarget.style,
                            navLinkHoverStyle
                          );
                        }
                      }}
                      onMouseLeave={e => {
                        Object.assign(
                          e.currentTarget.style,
                          getDashboardLinkStyle()
                        );
                      }}
                    >
                      Console
                    </Link>
                  </li>
                )}
              </ul>
            </nav>
            <div className="flex items-center gap-4">
              {isAuthenticated && <OrganizationSwitcher />}
              <ThemeSelector />
              <AuthComponent />
            </div>
          </div>

          {/* Mobile Menu Controls */}
          <div className="lg:hidden flex items-center gap-4">
            <ThemeSelector />
            <AuthComponent />
            <button
              onClick={toggleMenu}
              className={`p-2 rounded-md transition-all duration-200 transform ${
                isMenuOpen ? 'scale-110' : 'scale-100 hover:scale-105'
              }`}
              style={{
                color: 'var(--text-primary)',
                backgroundColor: isMenuOpen
                  ? 'var(--bg-secondary)'
                  : 'transparent',
                border: '1px solid var(--border)',
              }}
              onMouseEnter={e => {
                if (!isMenuOpen) {
                  e.currentTarget.style.backgroundColor = 'var(--bg-secondary)';
                }
              }}
              onMouseLeave={e => {
                if (!isMenuOpen) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
              aria-label="Toggle navigation menu"
              aria-expanded={isMenuOpen}
            >
              <div className="w-6 h-6 flex flex-col justify-center items-center">
                <span
                  className={`w-5 h-0.5 rounded-full transition-all duration-300 ease-in-out ${
                    isMenuOpen ? 'rotate-45 translate-y-1.5' : ''
                  }`}
                  style={{
                    backgroundColor: 'var(--text-primary)',
                    transformOrigin: 'center',
                  }}
                ></span>
                <span
                  className={`w-5 h-0.5 rounded-full my-1 transition-all duration-300 ease-in-out ${
                    isMenuOpen ? 'opacity-0 scale-0' : 'opacity-100 scale-100'
                  }`}
                  style={{ backgroundColor: 'var(--text-primary)' }}
                ></span>
                <span
                  className={`w-5 h-0.5 rounded-full transition-all duration-300 ease-in-out ${
                    isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''
                  }`}
                  style={{
                    backgroundColor: 'var(--text-primary)',
                    transformOrigin: 'center',
                  }}
                ></span>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div
          className={`lg:hidden transition-all duration-300 ease-in-out ${
            isMenuOpen
              ? 'max-h-[600px] opacity-100 mt-2 pointer-events-auto visible'
              : 'max-h-0 opacity-0 pointer-events-none invisible'
          }`}
          style={{
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            transformOrigin: 'top center',
            backgroundColor: isMenuOpen ? 'var(--bg-primary)' : 'transparent',
            borderRadius: isMenuOpen ? '0 0 12px 12px' : '0',
            boxShadow: isMenuOpen ? '0 4px 20px rgba(0, 0, 0, 0.1)' : 'none',
            // No overflow-hidden — allows the org switcher dropdown to escape
            overflow: isMenuOpen ? 'visible' : 'hidden',
          }}
        >
          <nav className="pt-4 pb-2">
            <ul className="flex flex-col gap-2 list-none m-0 p-0">
              <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '100ms' : '0ms' }}
              >
                <Link
                  to="/"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/')
                    );
                  }}
                >
                  Home
                </Link>
              </li>
              <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '150ms' : '0ms' }}
              >
                <Link
                  to="/about"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/about')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/about') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/about')
                    );
                  }}
                >
                  About
                </Link>
              </li>
              <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '200ms' : '0ms' }}
              >
                <Link
                  to="/services"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/services')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/services') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/services')
                    );
                  }}
                >
                  Services
                </Link>
              </li>
              <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '250ms' : '0ms' }}
              >
                <Link
                  to="/products"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/products')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/products') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/products')
                    );
                  }}
                >
                  Products
                </Link>
              </li>
              <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '300ms' : '0ms' }}
              >
                <Link
                  to="/pricing"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/pricing')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/pricing') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/pricing')
                    );
                  }}
                >
                  Pricing
                </Link>
              </li>
              {/* <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '300ms' : '0ms' }}
              >
                <Link
                  to="/portfolio"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/portfolio')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/portfolio') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/portfolio')
                    );
                  }}
                >
                  Portfolio
                </Link>
              </li> */}
              <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '350ms' : '0ms' }}
              >
                <Link
                  to="/contact"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/contact')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/contact') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/contact')
                    );
                  }}
                >
                  Contact
                </Link>
              </li>
              {/* <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '350ms' : '0ms' }}
              >
                <Link
                  to="/blog"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/blog')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/blog') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/blog')
                    );
                  }}
                >
                  Blog
                </Link>
              </li> */}
              {/* <li
                className={`transition-all duration-300 ease-out ${
                  isMenuOpen
                    ? 'opacity-100 translate-x-0'
                    : 'opacity-0 -translate-x-4'
                }`}
                style={{ transitionDelay: isMenuOpen ? '400ms' : '0ms' }}
              >
                <Link
                  to="/newsletter"
                  onClick={closeMenu}
                  className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                  style={getActiveLinkStyle('/newsletter')}
                  onMouseEnter={e => {
                    if (location.pathname !== '/newsletter') {
                      Object.assign(e.currentTarget.style, navLinkHoverStyle);
                    }
                  }}
                  onMouseLeave={e => {
                    Object.assign(
                      e.currentTarget.style,
                      getActiveLinkStyle('/newsletter')
                    );
                  }}
                >
                  Newsletter
                </Link>
              </li> */}

              {/* Authenticated user links for mobile */}
              {isAuthenticated && (
                <li
                  className={`transition-all duration-300 ease-out ${
                    isMenuOpen
                      ? 'opacity-100 translate-x-0'
                      : 'opacity-0 -translate-x-4'
                  }`}
                  style={{ transitionDelay: isMenuOpen ? '400ms' : '0ms' }}
                >
                  <Link
                    to={dashboardHref}
                    onClick={closeMenu}
                    className="block font-medium px-4 py-3 rounded-md transition-all duration-200 no-underline transform hover:translate-x-1"
                    style={getDashboardLinkStyle()}
                    onMouseEnter={e => {
                      const isDashboardActive =
                        location.pathname === '/console' ||
                        location.pathname.startsWith('/admin');
                      if (!isDashboardActive) {
                        Object.assign(e.currentTarget.style, navLinkHoverStyle);
                      }
                    }}
                    onMouseLeave={e => {
                      Object.assign(
                        e.currentTarget.style,
                        getDashboardLinkStyle()
                      );
                    }}
                  >
                    Console
                  </Link>
                </li>
              )}

              {/* Organization Switcher for mobile */}
              {isAuthenticated && (
                <li
                  className={`px-4 py-3 transition-all duration-300 ease-out ${
                    isMenuOpen
                      ? 'opacity-100 translate-x-0'
                      : 'opacity-0 -translate-x-4'
                  }`}
                  style={{ transitionDelay: isMenuOpen ? '500ms' : '0ms' }}
                >
                  <OrganizationSwitcher className="w-full" />
                </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
